import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/tendencias";

export const Route = createFileRoute("/_authenticated/tendencias")({
  head: () => ({
    meta: [
      { title: "Tendências — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Gráficos de consumo estimado por período, seção do cardápio, produto e insumo para orientar as compras.",
      },
      { property: "og:title", content: "Tendências — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Visualize tendências de vendas e consumo de insumos por período, seção, produto e insumo.",
      },
    ],
  }),
  component: PaginaRota,
});
